import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';

@Component({
  selector: 'app-main-optique',
  imports: [RouterOutlet],
  templateUrl: './main-optique.component.html',
  styleUrl: './main-optique.component.scss'
})
export class MainOptiqueComponent {}
